import axios from 'axios';
import { stringify } from 'query-string';

/** Default API client instance */
const ApiClient = axios.create({
  timeout: 10 * 1000,
  baseURL: window.origin,
  // Serialize parameters arrays with the syntax &param[]=value1,value2
  paramsSerializer: (params) => stringify(params, { arrayFormat: 'comma' }),
});

/** Request middleware for the ApiClient instance */
ApiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  },
);

/** Response middleware for the ApiClient instance */
ApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error);
  },
);

export default ApiClient;
